import { Component, inject } from '@angular/core';
import { OnInit, AfterViewInit, OnDestroy } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Observable, Subscription } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { AsyncPipe, CommonModule } from '@angular/common';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { CompanyInterface } from '@app/interface/company';
import { MatTableDataSource } from '@angular/material/table';
import { MatTableModule } from '@angular/material/table';
import { CompanyApi } from '@app/services/company-api';
import {
  PaginatedResponse,
  RecursiveInterface,
} from '@app/services/base-authenticated.service';
import { NgForm } from '@angular/forms';
import { CompanyAutocompleteComponent } from '@app/company-autocomplete/company-autocomplete';
import { Router } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import {
  MatPaginator,
  MatPaginatorModule,
  PageEvent,
} from '@angular/material/paginator';
import { ViewChild } from '@angular/core';
// import { LayoutComponent } from '../layout/layout.component';
import { ActivatedRoute } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { MatChipListbox, MatChipOption } from '@angular/material/chips';
import { MatChipsModule } from '@angular/material/chips';
import { EventEmitter, Input, Output } from '@angular/core';
import { ChangeDetectorRef } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmInvoiceDeleteComponent } from '@app/confirm-delete-dialog/confirm-delete-dialog.component';
import { LoadingDialogComponent } from '@app/loading-dialog/loading-dialog.component';
import { BackHeaderComponent } from '@app/back-header/back-header.component';
import {
  MatBottomSheet,
  MatBottomSheetModule,
  MatBottomSheetRef,
} from '@angular/material/bottom-sheet';
import {
  CompanyInvoicesBottomSheetComponent,
  CompanyInvoicesData,
} from '@app/company-invoices-bottom-sheet/company-invoices-bottom-sheet.component';
import { ToastService } from '@app/services/toast.service';

/**
 * @title Filter autocomplete
 */
@Component({
  selector: 'app-company-table',
  styleUrl: './company-table.scss',
  templateUrl: './company-table.html',
  imports: [
    CommonModule,
    MatTableModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatAutocompleteModule,
    ReactiveFormsModule,
    // AsyncPipe,
    // CompanyAutocompleteComponent,
    MatPaginatorModule,
    MatPaginator,
    // LayoutComponent,
    MatIconModule,
    MatButtonModule,
    MatCardModule,
    MatListModule,
    MatMenuModule,
    MatChipOption,
    MatChipsModule,
    MatProgressSpinnerModule,
    BackHeaderComponent,
    MatBottomSheetModule,
  ],
  standalone: true,
})
export class CompanyTable implements OnInit, AfterViewInit, OnDestroy {
  private toast = inject(ToastService);
  @ViewChild(MatPaginator) paginator!: MatPaginator;

  @Output() optionSelected = new EventEmitter<CompanyInterface>();

  displayedColumns: string[] = [
    'actions',
    'company_name',
    'iva_number',
    'email_address',
    'type',
    'cellphone',
    'address',
  ];

  // pageSize = 10;
  // pageSizeOptions = [5, 10, 25, 100];
  // totalItems = 0;
  // isLoading = false;

  newCompany: Partial<CompanyInterface> = {
    id: 1,
    company_name: '',
    organization_id: 1,
    company_id: 1,

    iva_number: '',
    ateco_code: '',
  };

  myControl = new FormControl('');
  companyNames: string[] = []; // Array to store company names
  filteredOptions!: Observable<string[]>;
  companySource = new MatTableDataSource<CompanyInterface>([]);
  filteredCompanies: CompanyInterface[] = [];

  filterOptions = [
    { name: 'Tutti', value: 'all' },
    { name: 'Aziende', value: 'AZIENDA' },
    { name: 'Persone', value: 'PERSONA' },
  ];
  selectedFilter = 'all';
  // filteredInvoices: InvoiceInterface[] = []; // For mobile cards

  applyTypeFilter(filterValue: string): void {
    this.selectedFilter = filterValue;

    if (filterValue === 'all') {
      // Show all companies
      this.companySource.filter = '';
    } else {
      // Filter by type
      this.companySource.filterPredicate = (
        data: CompanyInterface,
        filter: string,
      ) => {
        return data.type === filter;
      };
      this.companySource.filter = filterValue;
    }

    // Update the paginator length to reflect filtered results
    if (this.paginator) {
      this.paginator.firstPage();
    }
  }

  isLoading: boolean = false; // Initialize as false by default
  errorMessage: string | null = null;

  // getAllCompanies restituisce un Subject che non completa mai: si tiene la
  // sottoscrizione per poterla chiudere all'uscita dalla pagina.
  private companiesSub?: Subscription;

  constructor(
    private companyService: CompanyApi,
    private router: Router,
    private route: ActivatedRoute,
    private cdr: ChangeDetectorRef,
    private dialog: MatDialog,
    private bottomSheet: MatBottomSheet,
  ) {}

  ngOnInit() {
    // debug
    // const organizationId = this.route.snapshot.paramMap.get('organizationId');
    // console.log('Component organizationId:', organizationId);

    this.loadCompanies();

    // Initialize filteredOptions after companies are loaded
    this.filteredOptions = this.myControl.valueChanges.pipe(
      startWith(''),
      debounceTime(300),
      map((value: any) => this._filter(value || '')),
    );

    this.cdr.detectChanges();

    // const initEvent = {
    //   target: { value: '' }, // Default filter
    // } as unknown as Event;

    // this.applyFilter(initEvent);
  }

  ngOnDestroy() {
    this.companiesSub?.unsubscribe();
  }

  ngAfterViewInit() {
    // Connect the paginator to the data source after view init.
    // La paginazione e' tutta lato client (si caricano tutti i clienti):
    // al cambio pagina non serve ricaricare, ci pensa la data source.
    this.companySource.paginator = this.paginator;

    this.paginator._intl.itemsPerPageLabel = 'Elementi per pagina:';
    this.paginator._intl.nextPageLabel = 'Pagina successiva';
    this.paginator._intl.previousPageLabel = 'Pagina precedente';
    this.paginator._intl.firstPageLabel = 'Prima pagina';
    this.paginator._intl.lastPageLabel = 'Ultima pagina';

    this.paginator._intl.getRangeLabel = (
      page: number,
      pageSize: number,
      length: number,
    ) => {
      if (length === 0 || pageSize === 0) {
        return `0 di ${length}`;
      }

      const startIndex = page * pageSize;
      const endIndex =
        startIndex < length
          ? Math.min(startIndex + pageSize, length)
          : startIndex + pageSize;

      return `${startIndex + 1} - ${endIndex} di ${length}`;
    };
  }

  // private loadCompanies() {
  //   // const page = this.paginator?.pageIndex || 0;
  //   // const pageSize = this.paginator?.pageSize || this.pageSize;

  //   this.companyService
  //     .getCompanyList({
  //       // page: page + 1, // uses 1-based indexing
  //       // page_size: pageSize,
  //     })
  //     .subscribe({
  //       next: (companies: PaginatedResponse<CompanyInterface>) => {
  //         this.companySource.data = companies.results;
  //         this.companySource.paginator = this.paginator;
  //         // Extract company names from the response
  //         this.companyNames = companies.results.map(
  //           (company) => company.company_name
  //         );

  //         if (companies.count !== undefined) {
  //           // this.totalItems = companies.count;
  //           this.paginator.length = companies.count;
  //         }
  //         console.log('loaded companies');
  //       },
  //       error: (err: any) => {
  //         console.error('Error loading companies:', err);
  //         this.showErrorMessage('Failed to load companies');
  //       },
  //     });
  // }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.companyNames.filter((option) =>
      option.toLowerCase().includes(filterValue),
    );
  }

  private loadCompanies(sortDirection: 'asc' | 'desc' = 'asc') {
    const organization_id = Number(
      this.route.snapshot.paramMap.get('organizationId'),
    );

    // Prepare filter params
    const filterParams: any = {
      ordering: sortDirection === 'asc' ? 'company_name' : '-company_name',
    };
    filterParams.is_deleted = false; // hide deleted invoices

    this.isLoading = true;
    this.errorMessage = null;

    this.companiesSub?.unsubscribe();
    this.companiesSub = this.companyService
      .getAllCompanies<CompanyInterface>(organization_id, filterParams)
      .subscribe({
        next: (response: RecursiveInterface<CompanyInterface>) => {
          if (response.completed) {
            // All companies loaded across all pages
            const allCompanies = response.results;

            // Update data source with all companies
            this.companySource.data = allCompanies;
            this.companySource.paginator = this.paginator;

            // Extract company names from the complete dataset
            this.companyNames = allCompanies.map(
              (company) => company.company_name,
            );

            // Update pagination length with total count
            if (response.count !== undefined) {
              this.paginator.length = response.count;
            }

            console.log('All companies loaded', allCompanies.length);

            // Solo a caricamento completo: sulle pagine parziali la tabella
            // e' ancora vuota e comparirebbe lo stato "nessun cliente".
            this.isLoading = false;
            this.cdr.detectChanges();
          } else {
            // Optional: Show loading progress
            console.log(
              `Loaded ${response.results.length} companies so far...`,
            );
          }
        },
        error: (err: any) => {
          this.isLoading = false;
          console.error('Error loading companies:', err);
          this.showErrorMessage('Errore durante il caricamento.');
          this.cdr.detectChanges();
        },
      });
  }

  addNewCompany(form?: NgForm) {
    const organization_id = Number(
      this.route.snapshot.paramMap.get('organizationId'),
    );

    // validate required fields
    console.log(!this.newCompany.organization_id || !this.newCompany.id);
    console.log(this.newCompany);
    this.companyService
      .createCompany(organization_id, this.newCompany)
      .subscribe({
        next: (createdCompany: CompanyInterface) => {
          this.companySource.data = [
            ...this.companySource.data,
            createdCompany,
          ];
          this.showSuccessMessage(
            `${createdCompany.company_name} (ID ${createdCompany.id}) aggiunto!`,
          );
          this.resetForm(form);
        },
        error: (err: any) => {
          console.error('Error creating company:', err);
          this.showErrorMessage('Errore nella creazione di un nuovo cliente.');
        },
      });
  }

  onRowClick(company: CompanyInterface) {
    const org_id = this.route.snapshot.paramMap.get('organizationId');
    this.router.navigate([`/${org_id}/company`, company.id]);
  }

  navigateToNewCompany() {
    const org_id = this.route.snapshot.paramMap.get('organizationId');
    console.log(org_id);
    this.router.navigate([`/${org_id}/new_company`]);
  }

  navigateToNewInvoice(company?: CompanyInterface) {
    const org_id = this.route.snapshot.paramMap.get('organizationId');
    console.log(org_id);
    // console.log('All companies in table:', this.companySource.data);
    // console.log('Filtered companies:', this.filteredCompanies);

    // this.router.navigate([`/${org_id}/new_invoice`]);

    if (company) {
      // Pass company data via query parameters
      this.router.navigate([`/${org_id}/new_invoice`], {
        queryParams: {
          companyId: company.id,
          companyName: company.company_name,
        },
      });
    } else {
      this.router.navigate([`/${org_id}/new_invoice`]);
    }
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value
      .trim()
      .toLowerCase();

    // Combine search filter with type filter
    this.companySource.filterPredicate = (
      data: CompanyInterface,
      filter: string,
    ) => {
      const searchMatch =
        data.company_name.toLowerCase().includes(filterValue) ||
        data.iva_number.toLowerCase().includes(filterValue) ||
        data.email_address.toLowerCase().includes(filterValue) ||
        data.address.toLowerCase().includes(filterValue);

      const typeMatch =
        this.selectedFilter === 'all' || data.type === this.selectedFilter;

      return searchMatch && typeMatch;
    };

    this.companySource.filter = filterValue || ' '; // Use space if empty to trigger filtering
  }

  // soft delete
  async deleteCompany(company: CompanyInterface) {
    const organization_id = Number(
      this.route.snapshot.paramMap.get('organizationId'),
    );

    const dialogRef = this.dialog.open(ConfirmInvoiceDeleteComponent, {
      width: '90vw',
      maxWidth: '400px',
      /* Niente altezza fissa: con la barra azioni panna a filo bordo e' il
         contenuto a dettare l'altezza. Lo stile della superficie e' in
         styles.scss (.izy-confirm-dialog-panel): il dialog vive nell'overlay
         CDK, fuori dai componenti. */
      maxHeight: '90vh',
      panelClass: 'izy-confirm-dialog-panel',
      data: {
        companyName: company.company_name,
        /* Veste d'allarme: il cliente non torna indietro. Il dialog si mette
           da se' la panelClass .izy-danger-dialog-panel. */
        danger: true,
        message: 'Sicuro di voler eliminare il cliente dalla tua anagrafica?', // Custom message
        checkboxLabel: 'Confermo di voler eliminare il cliente e accetto', // Custom checkbox label
      },
    });

    const result = await dialogRef.afterClosed().toPromise();

    if (result) {
      // User confirmed deletion - show loading dialog
      const loadingDialogRef = this.dialog.open(LoadingDialogComponent, {
        width: '90vw',
        maxWidth: '400px',
        height: '300px',
        disableClose: true, // Prevent closing during loading
      });

      // Simulate 2-second delay + actual API call
      try {
        // Combine fake delay with actual API call
        await Promise.all([
          new Promise((resolve) => setTimeout(resolve, 2000)), // 2-second delay
          this.companyService
            .updateCompanyDetails(organization_id, company.id, {
              is_deleted: true,
            })
            .toPromise(),
        ]);

        // Close loading dialog
        loadingDialogRef.close();

        this.showSuccessMessage(
          `Fattura ${company.company_name} eliminata con successo!`,
        );
      } catch (err: any) {
        // Close loading dialog on error
        loadingDialogRef.close();

        console.error('Error deleting invoice:', err);
        this.showErrorMessage('Impossibile eliminare la fattura');
      }
    }
  }

  openCompanyInvoicesBottomSheet(company: CompanyInterface): void {
    const organizationId = Number(
      this.route.snapshot.paramMap.get('organizationId'),
    );

    const bottomSheetData: CompanyInvoicesData = {
      company_id: company.id,
      companyName: company.company_name,
      organizationId: organizationId,
    };

    this.bottomSheet.open(CompanyInvoicesBottomSheetComponent, {
      data: bottomSheetData,
      panelClass: 'custom-bottom-sheet',
    });
  }

  private resetForm(form?: NgForm) {
    if (form) {
      form.resetForm();
    }
    ((this.newCompany = {
      id: 1,
      company_name: '',
      organization_id: 1,
      company_id: 1,

      iva_number: '',
      ateco_code: '',
    }),
      console.log('reset'));
  }

  backToDashboard(): void {
    const org_id = this.route.snapshot.paramMap.get('organizationId');
    this.router.navigate([`/${org_id}/dashboard`]);
  }

  private showSuccessMessage(message: string): void {
    this.toast.success(message);
  }

  private showErrorMessage(message: string): void {
    this.toast.error(message);
  }
}
